import styled from 'styled-components';

export const StyledModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  max-width: 600px;
  max-height: 80%;
  border-radius: 15px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  padding: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #3c3c5c;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ChipContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-top: 16px;
`;
